<div class="container">
  <div class="content">
    <div id="instructions">
      <h1>Instructions</h1>
      <div class="instruct">
        <h2>Show / Hide these instructions</h2>
        <img
          src="images/instructions/computer_key_I.png"
          alt="I Key to Show / Hide Instructions"
          width="60"
        />
      </div>

      <div class="instruct">
        <h2>Move View Around</h2>
        <img
          src="images/instructions/computer_key_Arrow_Down.png"
          alt="Arrow Down Key to Look Down"
          width="60"
        />
        <img
          src="images/instructions/computer_key_Arrow_Left.png"
          alt="Arrow Left Key to Look Left"
          width="60"
        />
        <img
          src="images/instructions/computer_key_Arrow_Right.png"
          alt="Arrow Right Key to Look Right"
          width="60"
        />
        <img
          src="images/instructions/computer_key_Arrow_Up.png"
          alt="Arrow Up Key to Look Up"
          width="60"
        />
      </div>

      <div class="instruct">
        <h2>Interact with Hotspot Near center of Screen</h2>
        <img
          src="images/instructions/computer_key_Enter.png"
          alt="Enter or Return Key to Interact with Hotspot"
          width="120"
        />
      </div>

      <div class="instruct">
        <h2>Zoom In &amp; Out</h2>
        <img
          src="images/instructions/computer_key_num_row_Equals.png"
          alt="Plus Key on Number Row to Zoom In"
          width="60"
        />
        <img
          src="images/instructions/computer_key_num_row_Minus.png"
          alt="Minus Key on Number Row to Zoom Out"
          width="60"
        />
      </div>

      <div class="instruct">
        <h2>Close Popups</h2>
        <img
          src="images/instructions/computer_key_Esc.png"
          alt="Esc Key to Close Popups"
          width="60"
        />
      </div>

      <div class="instruct">
        <h2>Stop Auto Rotation</h2>
        <img
          src="images/instructions/computer_key_Esc.png"
          alt="Esc Key to Stop Auto Rotation"
          width="60"
        />
      </div>

      <div class="instruct">
        <h2>Previous &amp; Next Scene:</h2>
        <img
          src="images/instructions/computer_key_Less_than_Comma.png"
          alt="Less than Comma Key to Go to Previous Scene"
          width="60"
        />
        <img
          src="images/instructions/computer_key_Greater_than_Period.png"
          alt="Greater than Period Key to Go to Next Scene"
          width="60"
        />
      </div>

      <div class="instruct">
        <h2>Toggle Scene Selection Grid</h2>
        <img
          src="images/instructions/computer_key_Question_Forward_slash.png"
          alt="/ Key to Toggle Scene Selection Grid"
          width="60"
        />
      </div>
    </div>
  </div>
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
  }

  .content {
    flex: 1;
    padding: 1rem;
    overflow: auto;
  }

  p {
    line-height: 1.5;
  }

  img {
    border-radius: 10px;
  }

  .button {
    padding: 0.5em 0.6em;
    font-size: 1.25em;
    display: inline-block;
    background: transparent;
    color: #fff;
    border: 2px solid #fff;
    font-weight: bold;
    margin: 0.25em 0;
    border-radius: 10px;
  }

  .button:hover {
    background: #fff;
    color: var(--theme-color);
  }

  .text a {
    font-size: 1em;
    padding: 0;
    color: #000;
    background: none;
    border: none;
    font-weight: bold;
  }

  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background: #fff;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ddd;
  }
  /* mobile */
  @media (max-width: 768px) {
    .container {
      flex-direction: column;
    }

    .navigation {
      display: none;
    }

    .content {
      flex: 1;
      padding: 0;
    }

    .scene {
      padding: 0;
      margin: 0;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }
</style>
